var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerfil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 38,
    r: 38,
    fill: "#000E4B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4199 45.459C29.7988 43.6777 33.9922 42.7871 38 42.7871C42.0078 42.7871 46.1641 43.6777 50.4688 45.459C54.8477 47.166 57.0371 49.4297 57.0371 52.25V57.0371H18.9629V52.25C18.9629 49.4297 21.1152 47.166 25.4199 45.459ZM44.6797 35.2168C42.8242 37.0723 40.5977 38 38 38C35.4023 38 33.1758 37.0723 31.3203 35.2168C29.4648 33.3613 28.5371 31.1348 28.5371 28.5371C28.5371 25.9395 29.4648 23.7129 31.3203 21.8574C33.1758 19.9277 35.4023 18.9629 38 18.9629C40.5977 18.9629 42.8242 19.9277 44.6797 21.8574C46.5352 23.7129 47.4629 25.9395 47.4629 28.5371C47.4629 31.1348 46.5352 33.3613 44.6797 35.2168Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerfil);
export default __webpack_public_path__ + "static/media/perfil.07f48e934cac1f55661cb055f7148761.svg";
export { ForwardRef as ReactComponent };